import React from "react";

import styled, { css } from 'styled-components';
import style from '../../Styles/Components/AuthCount.module.css'
import { CloudfrontBackground } from "../CloudfrontAsset";

const AuthCount = ({ count, authImage ,countImage, layoutIndex, confirmInfo }) => {
    const AuthItem = styled(CloudfrontBackground)`
          ${props => props.isCount ? 
            css`
              width: 205px;
              height: 40px;
              
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            ` : 
            css`
              width: 100px;
              height: 100px;
              
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            `
          }
          
          &:not(:first-child) {
             margin-top: 24px;
          }
          
          &:first-child {
             margin-top: 0;
          }
          
          ${props => props.customStyle}
    `
  const authImg = (authImage) => {
        console.log(authImage);
      return (
          authImage ?
          <AuthItem
              imageUrl={authImage}
              logContext={{ component: 'AuthCount', assetType: 'authImage' }}
          />
              : null
      )
  }

  const countImg = (countImage, count) => {
      let index = count - 1;
        if (index < 0) {
            index = 0;
        } else if (index > 4) {
            index = 4;
        }

      return (
          countImage && countImage[index] ?
          <AuthItem
              isCount={true}
              imageUrl={countImage[index]}
              logContext={{ component: 'AuthCount', assetType: 'countImage', countIndex: index }}
          /> : null
      )
  }

  return (
    <div className={style.container}>
      <div className={style.titleContainer}>
        <span className={style.title}>{confirmInfo}</span>
      </div>
        {[1,5].indexOf(layoutIndex) > -1 ?   <div className={style.content}>
            {authImg(authImage)}
            {countImg(countImage, count)}
        </div> : null}

        {[2,6].indexOf(layoutIndex) > -1 ?   <div className={style.content}>
            {countImg(countImage, count)}
            {authImg(authImage)}
        </div> : null}

        {[3,7].indexOf(layoutIndex) > -1 ?   <div className={style.content}>
            {authImg(authImage)}
        </div> : null}

        {[4,8].indexOf(layoutIndex) > -1 ?   <div className={style.content}>
            {countImg(countImage, count)}
        </div> : null}
    </div>
  );
};

export default AuthCount;
